import { useMemo } from "react";
import { IService } from "./types";
import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { ChatOutlined } from "@mui/icons-material";

interface IProps{
  service: IService
}

export default function ServiceItem(props: IProps) {
  const { service } = props;

  const name = useMemo(() => {
    return (
      <Stack>
        <Box>{service.name}</Box>
        {!!service.cost && (
          <Typography variant={"caption"} color={"green"}>+{service.cost}₴</Typography>
        )}
      </Stack>
    )
  }, [service.name, service.cost])

  return (
    <Stack
      spacing={2}
      direction={"row"}
      alignItems={"center"}
    >
      <Box>{name}</Box>
      {!!service.descriptionfordriver && (
        <Box>
          <Tooltip title={(
            <Box sx={{ whiteSpace: "pre-wrap" }}>
              {service.descriptionfordriver}
            </Box>
          )}>
            <ChatOutlined
              color={"disabled"}
            />
          </Tooltip>
        </Box>
      )}
    </Stack>
  )
}